var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportantUpdates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 2.50107L1.75001 10.7363C1.75001 10.8744 1.86194 10.9863 2.00001 10.9863L13.6893 10.9863L10.2056 7.50257C9.71741 7.01442 9.71741 6.22296 10.2056 5.7348L13.6893 2.25107L2 2.25107C1.86193 2.25107 1.75 2.363 1.75 2.50107ZM0.250009 10.7363L0.25 2.50107C0.249999 1.53457 1.0335 0.751069 2 0.751069L14.2929 0.751068C15.4065 0.751068 15.9642 2.0975 15.1767 2.88495L11.443 6.61869L15.1768 10.3524C15.9642 11.1399 15.4065 12.4863 14.2929 12.4863L2.00001 12.4863C1.03351 12.4863 0.25001 11.7028 0.250009 10.7363Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.56445C1.41421 9.56445 1.75 9.90024 1.75 10.3145V16.8537C1.75 17.2679 1.41421 17.6037 1 17.6037C0.585786 17.6037 0.25 17.2679 0.25 16.8537V10.3145C0.25 9.90024 0.585786 9.56445 1 9.56445Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportantUpdates);
export default __webpack_public_path__ + "static/media/important-updates.e8b44c6ab5be5b547558c84578c713f5.svg";
export { ForwardRef as ReactComponent };